import React, { useState } from 'react'
import styles from './review.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import { createQuizTemplate } from '../../../../../../services/util/quizTemplates';
import { useNavigate } from 'react-router-dom';


const Review = (props) => {

    const [state, setState] = useState(false);
    const history = useNavigate();

    const submitDetails = async () => {
        setState(true)
        let response = await createQuizTemplate(props.values.quizName, props.values.quizSpecialization, props.values.duration, props.values.Description);
        if (response.success == true) {
            setState(false);
            history(`/company/quiz-templates/${response.data.quiz_template_id}`)
            props.handleClose();
        }
        else {
            setState(false)
        }
    }

    return (
        <div>

            <Container>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1 d-flex flex-column">
                        <div className={styles.rowSubTitle}>Quiz Name</div>
                        <div className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizNameReviewId"> {props.values.quizName}</div>
                    </Col>
                    <Col xs={12} className="mt-1 mb-1 d-flex flex-column">
                        <div className={styles.rowSubTitle}>Quiz Specialization</div>
                        <div className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizSpecializationReviewId">{props.values.quizSpecialization}</div>
                    </Col>
                    <Col xs={12} className="mt-1 mb-1 d-flex flex-column">
                        <div className={styles.rowSubTitle}>Time Limit&nbsp;(in minutes)</div>
                        <div className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_addedQuizTimeReviewId">{props.values.duration}</div>
                    </Col>
                    <Col xs={12} className="mt-1 mb-1 d-flex flex-column">
                        <div className={styles.rowSubTitle}>Description (Optional)</div>
                        <div className={styles.rowValues} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_addedDescriptionReviewId">{props.values.Description ? props.values.Description : 'N/A'}</div>
                    </Col>
                </Row>
            </Container>
            <hr className={styles.dividerLine} />
            <Row className={styles.actionBtnRow}>
                <div className={styles.navigateBtnCol}>
                    {<CustomButton
                        id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_reviewSubmitBtnId"
                        buttonType="submit"
                        label="Create Template"
                        type="primaryBtn"
                        disabled={state === true ? true : false}
                        backicon={
                            state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                : ''
                        }
                        handleClick={() => submitDetails()}
                    />}

                </div>
                <div className={styles.navigateBtnCol}>
                    {<CustomButton
                        id="one_way_template_review_cancel"
                        buttonType="button"
                        label="Back"
                        type="secondaryBtn"
                        handleClick={() => props.previousPage(1)}

                    />}
                </div>
            </Row>
        </div>
    )
}

export default Review
